




















































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Group from "@/components/miscellaneous/Group.vue";
import DateRangePicker from "@/components/forms/inputs/DateRangePicker.vue";
import {Request, User} from "@/modules/request/Request";
import RequestAllocations from "@/components/forms/request/RequestAllocations.vue";
import AreaZones from "./AreaZones.vue";
import _ from "lodash";
import {Getter} from "vuex-class";
import {Type} from "@/modules/request/Type";
import {BudgetAllocation} from "@/modules/budget/BudgetAllocation";
import {AllocationType} from "@/modules/budget/AllocationType";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";
import {Topic} from "@/modules/Topic";
import * as Constants from "@/Constants";
import {requestStatus} from "@/Constants";
import LogRepository from "@/repositories/request/LogRepository";
import AssignedUsers from "@/components/forms/request/AssignedUsers.vue";
import Status from "@/components/forms/request/Status.vue";
import Tag from "@/components/miscellaneous/Tag.vue";
import Owner from "@/model/cospirit-api/Owner";
import Followers from "@/components/forms/request/Followers.vue";
import MediaCampaignRepository from "@/repositories/media-campaign/MediaCampaignRepository";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import {Log} from "@/modules/request/Log";
import moment from "moment";
import RequestRepository from "@/repositories/request/RequestRepository";

const components = {
    Group,
    DateRangePicker,
    RequestAllocations,
    AssignedUsers,
    Status,
    Tag,
    LabelValue,
    AreaZones,
    Followers,
    SelectOwner
};

interface LogResult {
    message: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;
    movedTo?: string | undefined;
    loggedAt: string;
    userName: string;
}

@Component({components})
export default class Specifications extends Vue {
    @Prop(String) private title!: string;
    @Prop(Object) private request!: Request;
    @Prop(Boolean) private editable!: boolean;
    @Prop(Boolean) private disabled!: boolean;
    @Prop(Boolean) private disabledEdition!: boolean;
    @Prop(Number) private index!: number;
    @Prop(Boolean) private canEditRequest!: boolean;
    @Prop(Boolean) private drawerDisplayed!: boolean;
    @Prop(Boolean) private isEditingOrNew!: boolean;
    @Prop(Object) private parentRequest!: Request | null;

    @Getter("getTypes") public types!: Type[];
    @Getter("getBudgetAllocations") public allBudgetAllocations!: BudgetAllocation[];
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("getBudgetAllocations") public budgetAllocations!: BudgetAllocation[];
    @Getter("getAllTopics") public allTopics!: Topic[];
    @Getter("getCurrentUser") public currentUser!: User | null;
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;

    @Watch("request.topic.uuid")
    private topicChanged() {
        this.requestWishes = [];
    }

    @Watch("request.subtopic.uuid")
    private subtopicChanged() {
        this.requestWishes = [];
    }

    private requestType: string | null = "";
    private requestWishes: string[] = [];
    private logs: LogResult[] = [];
    private limitSizeText: number = 50;
    private isExpanded: boolean = false;
    private truncatedText: string = "";
    private readMoreText: string = "";
    public optionsZoneClient: any = [];
    public clientOptionZone: boolean = false;
    public loading: boolean = false;
    public hasMediaCampaign: boolean = false;
    public localRequest: Request|null = null;

    @Watch("request", {immediate: true, deep: true})
    private watchRequest() {
        this.localRequest = this.request;
        if (this.localRequest.uuid) {
            this.truncatedText = this.localRequest.brief.length > this.limitSizeText ?
                this.localRequest.brief.substring(0, this.limitSizeText).trim() :
                this.localRequest.brief.trim();
            this.readMoreText = this.isExpanded ?
                _.invoke(this.$options.filters, "trans", "readLess") :
                _.invoke(this.$options.filters, "trans", "readMore");
            this.getMediaCampaigns();
        }
    }

    @Watch("isExpanded")
    private watchExpanded() {
        this.readMoreText = this.isExpanded ? _.invoke(this.$options.filters, "trans", "readLess") :
            _.invoke(this.$options.filters, "trans", "readMore");
    }

    @Watch("types")
    private watchTypes() {
        if (this.requestType || !this.types.length) {
            return;
        }
        const defaultType = _.first(this.types) as Type;
        this.requestType = _.get(this.localRequest, "type.uuid", defaultType.uuid);
        if (this.localRequest) {
            _.set(this.localRequest, "type", { uuid: this.requestType });
        }
    }

    public mounted(): void {
        this.optionsZoneClient = _.find(Constants.optionsZone,
            (e: any) => e.canonical_name === this.currentOwner.canonicalName);
        if (this.optionsZoneClient && this.currentOwner.canonicalName === this.optionsZoneClient.canonical_name) {
            this.clientOptionZone = true;
        }
    }

    public created() {
        this.watchTypes();

        _.forEach(_.get(this.localRequest, "wishes", []), (wish) => {
            this.requestWishes.push(wish.uuid);
        });
    }

    private get optionsType(): any[] {
        return _.map(this.types, (type: any) => ({ key: type.uuid, label: type.label }));
    }

    private get allowAssigned(): boolean {
        return !!this.localRequest &&
            !!this.localRequest.uuid &&
            requestStatus.draft !== this.localRequest.status &&
            !!_.get(this.currentUser, "department.name", false)
            ;
    }

    private get allowFollow(): boolean {
        return !!this.localRequest && !!this.localRequest.uuid;
    }

    private get totalBudget(): number {
        return this.localRequest ? _.sumBy(this.localRequest.allocations, "amount") : 0;
    }

    private get requestTypeLabel(): string {
        const defaultType = _.first(this.types) as Type;
        const selectedType = _.find(this.types, (type: Type) => {
            return type.uuid === this.requestType;
        });

        return _.get(selectedType, "label", defaultType.label);
    }

    private get selectedScopeOwnerUuid(): string | null {
        return _.get(
            this.localRequest,
            "scopeOwner.uuid",
            null
        );
    }

    private async showLogs(): Promise<void> {
        if (!this.localRequest || !this.localRequest.uuid) {
            return;
        }
        try {
            const paramsLog = {filters: {requestUuid: this.localRequest.uuid}};
            const data = await LogRepository.get(paramsLog) as Log[];

            this.logs = data
                .map((log: Log): LogResult | null => {
                    const {message} = log;
                    const regExp = /\{([^\}]*)\}/g;
                    const matches = [...message.matchAll(regExp)];

                    if (matches.length === 0 || !matches[0] || !matches[0][1]) {
                        return null;
                    }

                    switch (matches[0][1]) {
                        case "requestHasBeenChanged":
                            if (!matches[1] || !matches[1][1]) {
                                return null;
                            }
                            return {
                                message: _.invoke(this.$options.filters, "trans", matches[0][1]) + " : ",
                                movedTo: matches[1][1],
                                loggedAt: log.loggedAt,
                                userName: log.user.displayName,
                            };
                        case "requestStatusHasBeenChanged":
                            if (!matches[1] || !matches[2] || !matches[1][1] || !matches[2][1]) {
                                return null;
                            }
                            return {
                                message: _.invoke(this.$options.filters, "trans", matches[0][1]) + " : ",
                                oldStatus: matches[1][1],
                                newStatus: matches[2][1],
                                loggedAt: log.loggedAt,
                                userName: log.user.displayName,
                            };
                        default:
                            return null;
                    }
                })
                .filter((log): log is LogResult => log !== null);

        } catch (error) {
            this.logs = [];
        }
    }

    private retrieveHierarchyOwnerUuid(request: Request): string | null {
        return _.get(request, "hierarchyOwner.uuid", null);
    }

    private computePropPrefix(index: number): string {
        return index === 0 ? "" : "children." + (index - 1) + ".";
    }

    private changeBeginDate(event: any): void {
        if (this.localRequest) {
            this.localRequest.beginDate = event.value;
            this.changeData();
        }
    }

    private changeType(event: string): void {
        if (this.localRequest) {
            _.set(this.localRequest, "type", {uuid: event});
            this.changeData();
        }
    }
    private truncateTextRequest(text: string): string {
        if (text.length <= 25) {
            return text;
        }
        return text.substring(0, 20) + "...";
    }

    private resetAllocations(budgetAllocationUuid: string[] | null = null): void {
        if (!this.localRequest) {
            return;
        }
        Vue.set(this.localRequest, "allocations", []);

        if (_.size(budgetAllocationUuid) > 0) {
            const budgetAllocation = _.find(this.allBudgetAllocations, (bAlloc: AllocationType) => {
                return bAlloc.uuid === _.first(budgetAllocationUuid) as string;
            });
            const optionRequestType = _.find(this.optionsType, (line: any) => {
                return line.label === _.get(budgetAllocation, "label", "");
            });
            if (optionRequestType) {
                this.requestType = optionRequestType.key;
                this.changeType(optionRequestType.key);
            }
        }
    }

    private changeData(): void {
        this.$emit("change");
    }

    private get wishAnswers(): any[] {
        const wishAnswers: any[] = [];
        const currentTopic = _.find(this.allTopics, (topic) => {
            return topic.uuid === _.get(this.localRequest, "topic.uuid", null);
        });
        const currentSubTopic = _.find(this.allTopics, (topic) => {
            return topic.uuid === _.get(this.localRequest, "subtopic.uuid", null);
        });

        _.forEach(_.get(currentTopic, "wishes", []), (wish) => {
            wishAnswers.push({key: wish.uuid, label: wish.label});
        });
        _.forEach(_.get(currentSubTopic, "wishes", []), (wish) => {
            wishAnswers.push({key: wish.uuid, label: wish.label});
        });

        return wishAnswers;
    }

    private wishesChange(wishUuid: string[] | string): void {
        this.requestWishes = (Array.isArray(wishUuid)) ?
            wishUuid :
            [wishUuid];

        const wishesToSave: any = [];
        _.forEach(this.requestWishes, (wish) => {
            wishesToSave.push({uuid: wish});
        });
        if (this.localRequest) {
            _.set(this.localRequest, "wishes", wishesToSave);
            this.changeData();
        }
        this.changeData();
    }

    private displaySelectedWishes(request: Request): string {
        const selectedWishes: string[] = [];
        _.forEach(_.get(request, "wishes", []), (wish) => {
            const wishLabel = _.find(this.wishAnswers, (answer) => {
                return answer.key === wish.uuid;
            });
            selectedWishes.push(_.get(wishLabel, "label", ""));
        });

        return selectedWishes.join(", ");
    }

    private getMediaCampaigns(): void {
        if (!this.localRequest || !this.localRequest.uuid) {
            this.hasMediaCampaign = false;
            this.$emit("has-media-campaign", this.hasMediaCampaign);
            return;
        }
        this.loading = true;
        const params = {
            filters: {
                request: this.localRequest.uuid
            },
            fields: [
                "uuid",
            ],
        };
        MediaCampaignRepository.get(params).then((data) => {
            if (data.length > 0) {
                this.hasMediaCampaign = true;
                this.$emit("has-media-campaign", this.hasMediaCampaign);
            }
            this.loading = false;
        });
    }

    private toggleReadMore(): void {
        this.isExpanded = !this.isExpanded;
    }

    private goToRequest(request: Request) {
        if (!request.uuid) {
            return;
        }
        this.$router.push({
            name: "edit_request",
            params: {
                uuid: request?.uuid,
            },
        });
    }

    private get canAddNewChildRequest() {
        const request = this.parentRequest ? this.parentRequest : this.localRequest;
        const mainRequestHasBeenSaved = _.get(request, "uuid", null) !== null;
        const childrenHaveBeenSaved = _.every(
            _.get(request, "children", []),
            (child: Request) => {
                return child.uuid !== null;
            }
        );

        return mainRequestHasBeenSaved && childrenHaveBeenSaved;
    }

    private get allRequests(): Request[] {
        if (!this.localRequest) {
            return [];
        }
        if (this.parentRequest) {
            return [this.parentRequest, ...this.parentRequest.children];
        }

        return [this.localRequest, ...this.localRequest.children];
    }

    private createChildRequest() {
        if (!this.localRequest) {
            return;
        }
        const request = this.parentRequest ? this.parentRequest : this.localRequest;
        const defaultData = {
            title: request.title,
            description: request.description,
            topic: {
                uuid: request.topic!.uuid,
            },
            subtopic: {
                uuid: request.subtopic!.uuid,
            },
            type: request.type,
            area: "",
            owner: {
                uuid: request.owner.uuid,
            },
            scopeOwner: {
                uuid: request.scopeOwner!.uuid,
            },
            createdBy: {
                displayName: "",
            },
            createdAt: moment().format("DD-MM-YYYY"),
        };

        if (request.hierarchyOwner) {
            _.set(defaultData, "hierarchyOwner", {uuid: request.hierarchyOwner.uuid});
        }

        RequestRepository.create({data: {owner: {uuid: this.ownerUuid}}}, defaultData).then((data: object) => {
            if (!data) {
                return;
            }
            this.$emit("request-created", data as Request);
        });
    }

    private getHierarchyOwnerLabel(request: Request) {
        let hierarchyOwnerFullName = _.get(request, "hierarchyOwner.fullName", "");

        if (_.get(request, "hierarchyOwner.clientCode1", "")) {
            hierarchyOwnerFullName = hierarchyOwnerFullName + " - "
                + _.get(request, "hierarchyOwner.clientCode1", "");
        }

        if (_.get(request, "hierarchyOwner.address", "") &&
            _.get(request, "hierarchyOwner.address.city", "")
        ) {
            hierarchyOwnerFullName = hierarchyOwnerFullName + " ("
                + _.get(request, "hierarchyOwner.address.city", "") + ")";
        }

        return hierarchyOwnerFullName;
    }
}
